<template>

    <div id="actualizar-planificacion-anual-puertos-modal">

        <Button
            :size="15"
            color="#ffc107"
            colorText="#ffffff"
            tooltip="Modificar planificación"
            icon="fa fa-edit"
            round
            :width="35"
            class="mr-2"
            @click.native="checkPlanificacionAnual.length > 0 && openModal('modal')"
            traslate
            :inactive="checkPlanificacionAnual.length != 0 ? false : true"
        />

        <ui-modal ref="modal" title="Actualizar planificación anual" size="normal" @close="limpiar()">

            <div class="d-flex flex-column">
                <div class="d-flex mb-4">

                    <!-- Filtro de asignación -->
                    <div style="position: fixed; width: 94%">
                        <div class="d-flex flex-column mt-3 ml-3" >

                            <fieldset-component texto="Carga masiva" class="mb-3"/>

                            <div class="d-flex align-items-center">

                                <div class="d-flex w-75 align-items-center">
                                    <div class="d-flex align-items-center justify-content-center">
                                        <p class="mr-3">Agregar</p> 
                                        <ui-textbox :disabled="dataMultipleSeleccionada.length ? false : true" type="number" placeholder="0" v-model="cantidadModel" :min="0" style="width: 50px;" class="text-center" @blur="cambiarValorSelect($event, 'cantidadModel'); validarCamposCargaMultiple()"/>
                                    </div>

                                    <div class="d-flex align-items-center justify-content-center">
                                        <p class="mx-3">contenedor(es) cada</p> 
                                        <select :disabled="dataMultipleSeleccionada.length ? false : true" style="margin-top: -10px !important; width:50px" @change="cambiarValorSelect($event, 'intervalosDeSemanaModel'); validarCamposCargaMultiple()">
                                            <option value="">0</option>
                                            <option v-for=" (item, index) in semanasOptions " :key="index" :value="item" v-text="item"></option>
                                        </select>
                                    </div>

                                    <div class="d-flex align-items-center justify-content-center">
                                        <p class="mx-3">semanas desde las semanas</p>
                                        <select :disabled="dataMultipleSeleccionada.length ? false : true" style="margin-top: -10px !important; width:50px" @change="cambiarValorSelect($event, 'rangoInicioModel'); validarCamposCargaMultiple()">
                                            <option value="">0</option>
                                            <option v-for=" (item, index) in semanasOptions " :key="index" :value="item" v-text="item"></option>
                                        </select>
                                    </div>    

                                    <div class="d-flex align-items-center justify-content-center">
                                        <p class="mx-3">hasta la semana</p> 

                                        <select :disabled="dataMultipleSeleccionada.length ? false : true" style="margin-top: -10px !important; width:50px" @change="cambiarValorSelect($event, 'rangoTerminoModel'); validarCamposCargaMultiple()">
                                            <option value="">0</option>
                                            <option v-for=" (item, index) in semanasOptions " :key="index" :value="item" v-text="item"></option>
                                        </select>
                                    </div>

                                    <div class="d-flex" style="margin-bottom:11px;">

                                        <Button text="Aplicar" :size="25" color="#ffc107" colorText="#ffffff" :width="100" :height="25" horizontal class="ml-3"
                                            @click.native="cargaMasiva()" :inactive="HabilitarCargaMultipleSeleccionada && dataMultipleSeleccionada.length ? false : true"
                                        />

                                        <Button :size="15" color="#3c8dbc" colorText="#ffffff" tooltip="Restablecer cambios" icon="fa fa-undo" :width="25" round class="ml-2"
                                                @click.native="restablecer()" />

                                    </div>
                                </div>

                                <div class="d-flex justify-content-end w-25" style="margin-top: -10px !important;">

                                    <div class="d-flex">

                                        <Button v-if="isUpdate" :size="17" color="#28a745" colorText="#ffffff" tooltip="Guardando cambios" text="Guardar cambios" icon="far fa-save" :width="130" 
                                                :height="35" round inactive horizontal class="ml-2"/>

                                        <Button v-else :size="17" color="#28a745" colorText="#ffffff" tooltip="Guardar cambios" icon="far fa-save" :width="130" :height="35" round class="ml-2"
                                            @click.native="actualizarPlanificacion()" :inactive="dataMultipleSeleccionada.length ? false : true" text="Guardar cambios" horizontal
                                        />

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                    
                    <!-- Tabla de datos -->
                    <div class="d-flex w-100" style="padding-top: 110px;">

                        <!-- Tabla consolidados -->
                        <div style="width: 44%; position: fixed; background-color:#fff;">
                            <table class="table">
                                <thead>
                                    <th></th>
                                    <th class="text-center">Puerto destino</th>
                                    <th class="text-center">Contenedor</th>
                                    <th class="text-center">Tipo producto</th>
                                    <th class="text-center">Consignatario(s)</th>
                                    <th class="text-center">Carga anual</th>
                                </thead>

                                <tbody>
                                    <tr v-for="(item, index) in data_consolidada" :key="index">

                                        <td class="text-center"><input style="text-align: center; margin-top: 11px; margin-left: 10px;" type="checkbox" @change="obtenerFilaCheckeada($event, index)" /></td>
                                        
                                        <template v-for=" (fila, index_fila) in item">

                                            <td v-if="index_fila != 1 && index_fila != 2" :key="index_fila" class="text-center" style="" >
                                                <div v-text="fila" style="margin-top: 5px;"></div>
                                            </td>
                                            
                                            <td v-else-if="index_fila == 1" class="text-center" :key="index_fila">
                                                <ui-select class="w-100" style="margin-bottom: 0px !important;" has-search placeholder="Seleccionar" 
                                                searchPlaceholder="Buscar" :options="lista_contenedores" :keys="{ value: 'id', label: 'name' }"  v-model="data_complementaria[index].container_selected" />
                                            </td> 
                                            
                                            <td v-else-if="index_fila == 2" class="text-center" :key="index_fila">
                                                <ui-select class="w-100" style="margin-bottom: 0px !important;" has-search placeholder="Seleccionar" 
                                                searchPlaceholder="Buscar" :options="lista_productos" :keys="{ value: 'id', label: 'name' }"  v-model="data_complementaria[index].product_selected" />
                                            </td> 

                                        </template>

                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Tabla Semanas -->
                        <div style="width: 56%; margin-left: 46.45%">
                            <table class="table" style="margin-right: 50px;">
                                <thead>
                                    <th class="text-center" v-for="(_, index) in cantidad_semanas" :key="index" v-text="index + 1"></th>
                                </thead>

                                <tbody>
                                    <tr v-for="(semanas, index_semanas) in data_semanas" :key="index_semanas">
                                        <td v-for="(semana, index_semana) in semanas" :key="index_semana" class="text-center" style="padding: 10.5px 5px; !important" >
                                            <input type="number" class="text-center" style="width:30px" min="0" maxlength="2" :value="semana" @blur="textboxVacios(index_semanas, index_semana, $event)" @keyup="validacionNumeros(index_semanas, index_semana, $event)" />
                                        </td>
                                    </tr>
                                </tbody>

                            </table>
                        </div>

                    </div>

                </div>
            </div>

        </ui-modal>

    </div>
  
</template>

<script>
    
    import { mapActions, mapState } from 'vuex'

    // Keen UI
    import UiModal from "keen-ui/src/UiModal";
    import UiTextbox  from "keen-ui/src/UiTextbox";
    import UiSelect  from "keen-ui/src/UiSelect";

    import Button from '../../../common/Button.vue'
    import FieldsetComponent from '../../../common/FieldsetComponent.vue';
    import { actualizarPlanificacionAnual } from '../../../../constants/lineas';

    export default {
        props : ['semanasDelAnio'],

        computed : {
            ...mapState('lineas',['habilitarEdicionMultipleAnual','dataAnioSeleccionado','checkPlanificacionAnual','lista_contenedores','lista_productos','lista_puertos','checkPlanificacionAnual']),
        },

        data(){
            return {
                // data : [],
                data_consolidada : [],
                data_semanas : [],
                data_complementaria: [],
                cantidad_semanas : 0,

                // Carga masiva
                cantidadModel: 0,
                intervalosDeSemanaModel: '',
                rangoInicioModel: '',
                rangoTerminoModel: '',

                // cantidad de semanas
                semanasOptions : [],
                dataMultipleSeleccionada: [],
                example : [],
                cargaMultipleSeleccionada: [],
                HabilitarCargaMultipleSeleccionada: false,
                contenedoresModel: [],
                productosModel: [],
                total_contenedores: 0,
                data_seleccionada : [],
                isUpdate: false,

            }
        },

        components: { Button, UiModal, UiTextbox, UiSelect, FieldsetComponent },
       
        methods : {

            ...mapActions('lineas',['actionSetDataPlanificacionAnualTabla','actionSetClearCheckPlanificacionAnual']),

            openModal(ref) {
                this.$refs[ref].open();
            },

            closeModal(ref) {
                this.$refs[ref].close();
            },

            obtenerSumaAnual(fila){

                let semanas = this.data_semanas[fila];
                let cargaAnual = 0;

                semanas.map( item => {
                    cargaAnual += parseInt(item);
                });

                this.data_consolidada[fila][4] = cargaAnual;
                let data_semanas_temp = this.data_consolidada;

                this.data_consolidada = [];
                this.data_consolidada = data_semanas_temp;

            },

            cargaMasiva(){

                const rango_inicial = this.rangoInicioModel - 1;
                const rango_termino = this.rangoTerminoModel - 1;
                const intervalos    = parseInt(this.intervalosDeSemanaModel);
                const valor         = this.cantidadModel;

                this.dataMultipleSeleccionada.map( fila_check => {

                    const fila = fila_check.data;
                    const index_fila = fila_check.index;

                    let i    = 0;
                    let flag = true;

                    fila.map( (_, index) => {

                        if(index >= rango_inicial  && index <= rango_termino){

                            // Cuando comienza desde la semana 1
                            if(rango_inicial == i && flag){

                                this.data_semanas[index_fila][index] = valor;

                                i    = 0;
                                flag = false;

                            }else{
                                // Cuando no comienza desde la semana 1
                                if (rango_inicial == index && flag) {

                                    this.data_semanas[index_fila][index] = valor;

                                    i    = 0;
                                    flag = false;
                                    
                                // Despúes de la primera semana seleccionada
                                }else if(index > 0 && intervalos == i){

                                    this.data_semanas[index_fila][index] = valor;
                                    i = 0;

                                }
                            }
                            
                            i++;
                            
                        }
                        
                    });

                    this.obtenerSumaAnual(index_fila);

                });

                let data_semanas_temp = this.data_semanas;
                this.data_semanas     = [];
                this.data_semanas     = data_semanas_temp;

            },

            generarSemanasAnioSeleccionado(){
                
                for (let index = 1; index <= this.semanasDelAnio; index++) {
                    this.semanasOptions.push(index);
                }

            },

            cambiarValorSelect(event, model){

                const valor = event.target.value;

                switch (model) {
                    case 'cantidadModel':
                        this.cantidadModel = parseInt(valor);
                        break;

                    case 'intervalosDeSemanaModel':
                        this.intervalosDeSemanaModel = valor;
                        break;

                    case 'rangoInicioModel':
                        this.rangoInicioModel = valor;
                        break;

                    case 'rangoTerminoModel':
                        this.rangoTerminoModel = valor;
                        break;
                
                }


            },

            obtenerFilaCheckeada(event, index){

                const estado                  = event.target.checked;
                let filtrada                  = [] ;

                if (estado) {
                    this.dataMultipleSeleccionada.push({index, data : this.data_semanas[index]});
                } else {
                    this.dataMultipleSeleccionada.filter((item) => item.index != index && filtrada.push(item));
                    this.dataMultipleSeleccionada = filtrada;
                }

            },

            validarCamposCargaMultiple(){
                if(this.cantidadModel >= 0 && this.intervalosDeSemanaModel != '' && this.rangoInicioModel != '' && this.rangoTerminoModel){
                    this.HabilitarCargaMultipleSeleccionada = true;
                }else{
                    this.HabilitarCargaMultipleSeleccionada = false;
                }
            },

            restablecer(){
                this.data_semanas = [];
                this.data_semanas = JSON.parse(sessionStorage.getItem("data_semanas"));

                // Vuelve a sumar los valores totales para la columna "Carga anual"
                this.data_semanas.map( (_, index) =>{
                    this.obtenerSumaAnual(index);
                });

            },

            async actualizarPlanificacion(){

                let id_plan             = '';
                let ports               = [];
                this.isUpdate           = true;
                this.total_contenedores = 0;
                this.$vToastify.loader('Almacenando planificación');

                this.dataMultipleSeleccionada.map( item => {

                    const {index, data} = item; 
                    const complementaria = this.data_complementaria[index];
                    let { weeks, annual_plan_id, container_selected, product_selected, new : isNew} = complementaria; 

                    id_plan = annual_plan_id;

                    weeks.map( (semana, index) => {
                       semana.length > 1 && (semana.annual_planning_id = data[index]);
                       semana.annual_qty = parseInt(data[index]);
                    });

                    this.total_contenedores += complementaria.total;

                    if (isNew) {

                        ports.push({
                            "new"          : isNew,
                            "port_id"      : complementaria.port_id,
                            "container_id" : container_selected.id,
                            "product_id"   : product_selected.id,
                            "weeks"        : this.data_semanas[index]
                        });
                        
                    }else{

                        ports.push({
                            "port_id"      : complementaria.port_id,
                            "container_id" : container_selected.id,
                            "product_id"   : product_selected.id,
                            "weeks"        : weeks
                        });

                    }
                });

                let data = [];

                data.push({"plan_id":id_plan, "total":this.total_contenedores, "ports":ports});

                const sql = await actualizarPlanificacionAnual({"plans":data});

                if (sql.code == 200) {

                    this.actionSetDataPlanificacionAnualTabla();
                    this.$vToastify.stopLoader();
                    this.$vToastify.success( sql.message, "Proceso finalizado");
                    this.closeModal('modal');
                    
                    this.isUpdate = false;
                    this.actionSetClearCheckPlanificacionAnual();
                    this.dataMultipleSeleccionada = [];
                    
                } else {
                    this.$vToastify.stopLoader();
                    this.$vToastify.error( sql.message, "Proceso finalizado");
                    this.isUpdate = false;
                }

            },

            textboxVacios(fila, posicion, e){

                let valor = e.target.value;

                if (valor == '') {
                    this.data_semanas[fila][posicion] = 0;

                    let dataTemp1 = this.data_semanas;
                    this.data_semanas = [];
                    this.data_semanas = dataTemp1;    
                    
                    this.obtenerSumaAnual(fila);
                }

            },

            textBoxSemana(fila, posicion, e){

                let valor = parseInt(e.target.value);

                this.data_semanas[fila][posicion] = valor;
                this.data_complementaria[fila].total = this.data_consolidada[fila][4];

                let dataTemp = this.data_semanas;
                this.data_semanas = [];
                this.data_semanas = dataTemp;

                this.obtenerSumaAnual(fila);

            },

            validacionNumeros(fila, posicion, e){
    
                let valor = e.target.value;

                if (e.keyCode == 188 || e.keyCode == 189 || e.keyCode == 190 || e.keyCode == 69 || e.keyCode == 109 || e.keyCode == 110 ) {
                    let dataTemp1 = this.data_semanas;
                    this.data_semanas = [];
                    this.data_semanas = dataTemp1;
                    
                    return false;
                }

                if (valor >= 0 && valor != '') {
                    this.textBoxSemana(fila, posicion, e);  
                }
    
            },

            limpiar(){
                this.dataMultipleSeleccionada = [];
            }

        },

        watch : {

            checkPlanificacionAnual : function(_new){

                    let data_consolidada       = [];
                    let data_semanal           = [];

                    this.data_consolidada      = [];
                    this.data_semanas          = [];
                    this.data_complementaria   = [];
                    this.cantidad_semanas      = 0;

                    sessionStorage.removeItem("data_semanas");

                    if (_new.length > 0) {

                        _new.map( item => {

                            const { data, data_complementaria } = item.data;
                            const {annual_plan_id, container_selected, port_id, product_selected, total, weeks} = data_complementaria;

                            data.map( (fila, index_fila) => index_fila <= 4 ? data_consolidada.push(fila) : data_semanal.push(fila));

                            this.data_consolidada.push(data_consolidada);
                            this.data_semanas.push(data_semanal);

                            this.data_complementaria.push({annual_plan_id, container_selected, port_id, product_selected, total, weeks, new:item.data.new});

                            this.cantidad_semanas = data_semanal.length;

                            data_consolidada = [];
                            data_semanal     = [];

                        });

                        sessionStorage.setItem("data_semanas", JSON.stringify(this.data_semanas) );
                        
                    }

            },

            semanasDelAnio : function(_new){
                _new && this.generarSemanasAnioSeleccionado();
            },

        }
    }
</script>

<style>

    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
    }

    input[type=number] { -moz-appearance:textfield; }

    #actualizar-planificacion-anual-puertos-modal .ui-modal--size-normal > .ui-modal__wrapper > .ui-modal__container{
        width: 95% !important;
    }

    #actualizar-planificacion-anual-puertos-modal .ui-modal__body {
        padding: 0;
    }

</style>